import { AxiosError } from 'axios';

const nonEmptyString = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0;

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const responseData = (error as AxiosError<unknown>)?.response?.data;

  if (nonEmptyString(responseData)) {
    return responseData;
  }

  if (responseData && typeof responseData === 'object') {
    const { message, error: responseError } = responseData as Record<string, unknown>;
    if (nonEmptyString(message)) return message;
    if (nonEmptyString(responseError)) return responseError;
    return fallback;
  }

  const errorMessage = (error as { message?: unknown })?.message;
  return nonEmptyString(errorMessage) ? errorMessage : fallback;
};
